import styled from 'styled-components'
import { spaces } from 'styles/mixins'

export const ChipsContainer = styled.div`
  max-width: 85%;
  padding: ${spaces.normal};
`
